<template>
  <v-form ref="form">
    <v-row class="mt-1">
      <v-col cols="12">
        <v-text-field
          v-model="form.nombre"
          :label="$t('listaPreciosVenta.labels.nombre')"
          :rules="[required]"
          :counter="80"
          maxlength="80"
          outlined
          dense
          required
        />
      </v-col>
    </v-row>
    <div class="subtitle-1 mt-1 mb-3">Fórmula de precio de venta</div>
    <formula-builder v-model="form.formulaConfig" />
  </v-form>
</template>

<script>
import FormulaBuilder from "./FormulaBuilder.vue";

export default {
  name: "ListaPreciosVentaForm",
  components: { FormulaBuilder },
  props: {
    value: {
      type: Object,
      default: () => ({
        nombre: "",
        formulaConfig: { formula: "", margenDefault: null, tipoRedondeo: null },
      }),
    },
  },
  data() {
    return {
      form: this.buildForm(this.value),
    };
  },
  watch: {
    value(val) {
      const next = this.buildForm(val);
      if (JSON.stringify(next) !== JSON.stringify(this.form)) {
        this.form = next;
      }
    },
    form: {
      handler(val) {
        this.$emit("input", { ...val });
      },
      deep: true,
    },
  },
  methods: {
    buildForm(data) {
      return {
        nombre: data?.nombre || "",
        formulaConfig: {
          formula:
            data?.formulaConfig?.formula ||
            "precio_compra * (1 - descuento/100) * (1 + iva/100) * (1 + margen/100)",
          margenDefault: data?.formulaConfig?.margenDefault ?? null,
          tipoRedondeo: data?.formulaConfig?.tipoRedondeo ?? null,
        },
      };
    },
    required(v) {
      return !!v || this.$t("common.fieldRequired");
    },
    validate() {
      return this.$refs.form.validate();
    },
  },
};
</script>
